const colors = {
  primaryPurple: "#5A2FB1",
  primaryBlack: "#180B32",
  transparentPrimaryPurple: "rgba(90, 47, 177, 0.5)",
  transparentBlack: "rgba(24, 11, 50, .2)",
  lightPurple: "rgb(234, 231, 246)",
  tonedGrey: "#B5B2BA",
  black: "#111111",
  darkGrey: "#4D4B51",
  darkRed: "#E13D00",
  transparent: "transparent",
  white: "#FFFFFF",
  transparentWhite: "rgba(255, 255, 255, 0.5)",
  seaShell: "#F1F1F1",
  androidAppBarBg: "#F5F5F5",
  veryLightGrey: "#EEEEEE",
  lightGrey: "#DDDDDD",
  midGrey: "#CCCCCC",
  midDarkGrey: "#9b9b9b",
  grey: "#fafafa",
  secondaryPurple: "#7555B7",
  darkPurple: "#2C1064",
  lightGreen: "#BCDEDE",
  primaryGreen: "#348288",
  darkGreen: "#114044",
  brightGreen: "#4CAF50",
  beige: "#F5F5F1",
  lightYellow: "#FFDAA0",
  primaryYellow: "#FDBA50",
  darkYellow: "#523300",
  lightRed: "#FFD6C4"
};

export default colors;
